import { Component } from '@angular/core';

@Component({
	selector: 'cmv-success-message',
	templateUrl: './success-message.component.html',
	styleUrls: ['./success-message.component.scss'],
})
export class SuccessMessageComponent {
	constructor() {}
}
